import "./j_community.css";

import Map from "../../../assets/Map.svg";
import { useMediaQuery } from "react-responsive";

function Join_community() {
  const Mobile = useMediaQuery({ maxWidth: 760 });
  const Tab = useMediaQuery({ minWidth: 760 });
  return (
    <>
      <div className="container-fluid">
        {Tab && (
          <div className="j_community">
            <div className="row justify-content-center ">
              <div className="col-xl-6 col-md-6 col-12  d-flex justify-content-center">
                <div className="jcommunity_tit pt-5 mt-5">
                  <p className="jcommunity_defn mt-5 pt-5 ms-5">
                    Join The Community Where Millions<br></br> of People Are
                    United Through<br></br>
                    Sports.
                  </p>
                  <br></br>
                  <button
                    type="button"
                    className="join_btn btn btn-success ms-5"
                  >
                    PARTNER WITH US
                  </button>
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-12  d-flex justify-content-center">
                <div className="community_map">
                  <img src={Map} alt="map" className="img-fluid"></img>
                </div>
              </div>
            </div>
          </div>
        )}

        {Mobile && (
          <>
            <div className="j_community">
              <div className="row justify-content-center ">
                <div className="col-xl-6 col-md-6 col-12  d-flex justify-content-center">
                  <div className="jcommunity_tit pt-5 mt-5">
                    <p className="jcommunity_defn mt-5 pt-5 ms-5">
                      Join The Community Where Millions<br></br> of People Are
                      United Through<br></br>
                      Sports.
                    </p>
                  
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 col-12  d-flex justify-content-center">
                  <div className="community_map">
                    <img src={Map} alt="map" className="img-fluid"></img>
                  </div>
                </div>
              </div>
              <div className="col-6  d-flex justify-content-center ms-5">
              <button type="button" className="join_btn btn btn-success ms-5">
                PARTNER WITH US
              </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Join_community;
